import React, { useState, useEffect } from "react"

//controls
import { Button, Col, Row, Label } from "reactstrap"

//react form
import { FormProvider, useForm, Controller } from "react-hook-form"

//navigation
import { Link, useNavigate, useParams } from "react-router-dom"

//validation
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"

//redux
import { useSelector, useDispatch } from "react-redux"

//custom hooks
import { useDeepCompareEffect, useUserDetail } from "hooks"

import Select from "react-select"

//Date filter
import Moment from "moment"

import {
  addSubject as onAddSubject,
  updateSubject as onUpdateSubject,
} from "store/actions"
import Spinners from "components/Common/Spinner"
import { isEmpty } from "lodash"

import {
  TextInput,
  DropdownInput,
  DateInput,
  NumberInput,
  ToggleInput,
} from "components/Common/Controls"
import { EnumRoleTypes } from "helpers/enum_helper"

function BasicInfoTab({ subject, loading }) {
  const navigate = useNavigate()
  const { id } = useParams()
  const dispatch = useDispatch()
  const [isLoading, setLoading] = useState(loading)

  /**
   * Form Validation Schema
   */
  const schema = yup.object().shape({
    TrainingSubject: yup.string().required("Required"),
    Active: yup.bool(),
  })

  const methods = useForm({
    mode: "onChange",
    defaultValues: {
      TrainingSubject: "",
      IsActive: true,
    },
    resolver: yupResolver(schema),
  })
  const { reset, control, formState, setValue, getValues, trigger, watch } =
    methods
  const { errors, isValid } = formState

  useDeepCompareEffect(() => {
    function updateProfileState() {
      //reset form with server data
      reset(subject)
    }

    updateProfileState()
  }, [dispatch])

  const onCancelClick = () => {
    navigate("/subjects")
  }

  const handleSave = () => {
    trigger() //for form validation
    if (isValid) {
      if (isEmpty(subject)) {
        dispatch(onAddSubject(getValues()))
      } else {
        dispatch(onUpdateSubject(getValues()))
      }
      if (!isEmpty(id)) {
        navigate("/subjects")
      }
    }
  }

  if (isLoading) {
    return <Spinners setLoading={setLoading} />
  }

  return (
    <FormProvider {...methods}>
      <Row>
        <Col sm="4">
          <div className="mb-3">
            <TextInput
              label="Training Subject"
              id="TrainingSubject"
              required={true}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <div className="mb-3">
          <ToggleInput label="Active" id="Active" />
        </div>
      </Row>
      <div className="d-flex flex-wrap gap-2">
        <Button color="primary" className="btn" onClick={handleSave}>
          {isEmpty(subject) ? "Save" : "Update"}
        </Button>
        <Button
          type="submit"
          color="secondary"
          onClick={onCancelClick}
          className=""
        >
          Cancel
        </Button>
      </div>
    </FormProvider>
  )
}
export default BasicInfoTab
